<div class="bav-view-switch" (click)="viewToggled.emit()">
    <i class="bav-switch-chat" [class.bav-switch-selected]="selectedView === 'chat'">chat</i>
    <i class="bav-switch-overview"  [class.bav-switch-selected]="selectedView === 'overview'" >visibility</i>
</div>
